import { faCheck, faEdit, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TItem } from '@molecules/functionalMenu';

export function getFunctionalMenuItems({
    editing,
    handleAbortEditing,
    updateTemplate,
    updateSchedule,
    saveAsTemplate,
    updateScheduleFromTemplate,
    setNewTemplateName,
    setNewTemplateModalVisible,
    wpMode,
    tpEditMode,
    stpState,
    wpName,
    suggestScheduleName,
    handleEditing,
    scheduleChanged,
    isTemplateNameChanged,
    isNewSchedule,
}: {
    editing: boolean;
    scheduleChanged: boolean;
    tpEditMode: boolean;
    wpMode: boolean;
    stpState: any;
    handleAbortEditing: () => void;
    updateTemplate: () => void;
    updateSchedule: () => void;
    saveAsTemplate: () => void;
    updateScheduleFromTemplate: () => void;
    setNewTemplateName: (name: string) => void;
    setNewTemplateModalVisible: (visible: boolean) => void;
    wpName: string;
    suggestScheduleName: () => string;
    handleEditing: () => void;
    isTemplateNameChanged: boolean;
    isNewSchedule?: boolean;
}): TItem[] {
    let items: TItem[] = [];

    if (editing) {
        items.push({
            key: 'abort',
            label: 'Отменить',
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: handleAbortEditing,
        });

        if (
            (scheduleChanged && !tpEditMode && !wpMode) ||
            (stpState.selectedTemplateId != null && tpEditMode && scheduleChanged) ||
            (tpEditMode && isTemplateNameChanged && stpState.selectedTemplateId != null) ||
            (wpMode && stpState.selectedTemplateId != null && scheduleChanged)
        ) {
            items.push({
                key: 'save',
                label:
                    (stpState.selectedTemplateId != null && !wpMode) || isTemplateNameChanged
                        ? 'Обновить шаблон'
                        : isNewSchedule
                        ? 'Создать график'
                        : 'Обновить график',
                icon: <FontAwesomeIcon icon={faCheck} />,
                onClick:
                    stpState.selectedTemplateId != null && !wpMode
                        ? updateTemplate
                        : updateSchedule,
            });
        }

        if (wpMode && scheduleChanged && stpState.selectedTemplateId == null) {
            items.push({
                key: 'save',
                label: isNewSchedule ? 'Создать график' : 'Обновить график',
                icon: <FontAwesomeIcon icon={faCheck} />,
                onClick: updateSchedule,
            });
        }

        if (
            (wpMode && stpState.selectedTemplateId == null && scheduleChanged) ||
            (wpMode && stpState.selectedTemplateId != null && scheduleChanged) ||
            (tpEditMode && stpState.selectedTemplateId == null && stpState.isCreating)
        ) {
            items.push({
                key: 'save-template',
                label: 'Сохранить как шаблон',
                icon: <FontAwesomeIcon icon={faCheck} />,
                onClick:
                    tpEditMode && stpState.selectedTemplateId == null
                        ? () => saveAsTemplate()
                        : () => {
                              setNewTemplateName(wpName + ' ' + suggestScheduleName());
                              setNewTemplateModalVisible(true);
                          },
            });
        } else if (wpMode && stpState.selectedTemplateId != null && !scheduleChanged && !isNewSchedule) {
            items.push({
                key: 'update-from-template',
                label: 'Применить шаблон к сотруднику',
                icon: <FontAwesomeIcon icon={faEdit} />,
                onClick: updateScheduleFromTemplate,
            });
        }
    } else {
        items.push({
            key: 'edit',
            label: 'Редактировать',
            icon: <FontAwesomeIcon icon={faEdit} />,
            onClick: () => handleEditing(),
        });
    }

    return items;
}
